// /src/pages/UnderMaintenance.jsx

import React, { useEffect } from 'react';
import { useStatus } from "../StatusContext";

function UnderMaintenance() {
    const { networkStatus, serverStatus, maintenance } = useStatus();

    const isClientOffline = networkStatus === "offline";
    const isBackendUnreachable = serverStatus === "unreachable";
    const isBackendMaintenance = maintenance === true;

    // English comment: dynamic maintenance message.
    let maintenanceText = "";

    if (isClientOffline) {
    maintenanceText = "Internet connexion failure.\nCheck your internet.";
    } else if (isBackendUnreachable || isBackendMaintenance) {
    maintenanceText = "MAINTENANCE LEVEL 3.14\nIn progress...";
    } else {
    maintenanceText = "MAINTENANCE";
    }

    
    useEffect(() => {
        const canvas = document.getElementById('backgroundCanvas');
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        let stars = [];
        const FPS = 60;
        let mouse = { x: 0, y: 0 };

        for (let i = 0; i < 100; i++) {
            stars.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 1 + 1,
                vx: Math.floor(Math.random() * 50) - 25,
                vy: Math.floor(Math.random() * 50) - 25
            });
        }

        function draw() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.globalCompositeOperation = "lighter";

            stars.forEach((star) => {
                ctx.fillStyle = "#fff";
                ctx.beginPath();
                ctx.arc(star.x, star.y, star.radius, 0, 2 * Math.PI);
                ctx.fill();
                ctx.fillStyle = 'black';
                ctx.stroke();
            });

            stars.forEach((starI) => {
                ctx.moveTo(starI.x, starI.y);
                if (distance(mouse, starI) < 150) ctx.lineTo(mouse.x, mouse.y);
                stars.forEach((starII) => {
                    if (distance(starI, starII) < 150) {
                        ctx.lineTo(starII.x, starII.y);
                    }
                });
            });

            ctx.lineWidth = 0.05;
            ctx.strokeStyle = 'white';
            ctx.stroke();
        }

        function update() {
            stars.forEach((star) => {
                star.x += star.vx / FPS;
                star.y += star.vy / FPS;

                if (star.x < 0 || star.x > canvas.width) star.vx = -star.vx;
                if (star.y < 0 || star.y > canvas.height) star.vy = -star.vy;
            });
        }

        function tick() {
            draw();
            update();
            requestAnimationFrame(tick);
        }

        function distance(point1, point2) {
            let xs = point2.x - point1.x;
            xs *= xs;
            let ys = point2.y - point1.y;
            ys *= ys;
            return Math.sqrt(xs + ys);
        }

        canvas.addEventListener('mousemove', (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        });

        tick();

        return () => {
            canvas.removeEventListener('mousemove', mouse);
        };
    }, []);

    return (
        <div className='under-maintenance'>
            <canvas id="backgroundCanvas"></canvas>
            <div className="maintenance-container">
                <a className="maintenance" href="/">
                    {maintenanceText.split("\n").map((line, i) => (
                        <React.Fragment key={i}>
                            {line}<br />
                        </React.Fragment>
                    ))}
                    <div className="svg-container">
                        <svg fill="#4b0505" width="193px" height="193px" viewBox="0 0 512.00 512.00" xmlns="http://www.w3.org/2000/svg" stroke="#4b0505" strokeWidth="10.751999999999999" transform="matrix(-1, 0, 0, 1, 0, 0)">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"></g>
                            <path d="M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"></path>
                        </svg>
                    </div>
                </a>
            </div>
        </div>
    );
}

export default UnderMaintenance;
